import type { EditorAPI } from '#packages/editorAPI';
import type { CompRef } from '@wix/document-services-types';
import type {
  LegacyBehaviorObject,
  BehaviorObject,
} from 'types/documentServices';

export function removeBehaviorsByAction(
  editorAPI: EditorAPI,
  compRef: CompRef | CompRef[],
  actionName: string,
  viewMode: 'DESKTOP' | 'MOBILE',
) {
  const behaviors: LegacyBehaviorObject[] | BehaviorObject[] =
    editorAPI.components.behaviors.get(compRef);

  getBehaviorByAction(behaviors, actionName, viewMode).forEach(
    (behavior: LegacyBehaviorObject | BehaviorObject) => {
      //maybe need changes here
      editorAPI.components.behaviors.remove(compRef, {
        action: actionName,
        // @ts-expect-error
        viewMode: behavior?.viewMode,
      });
    },
  );
}

export function getBehaviorByAction(
  behaviors: LegacyBehaviorObject[] | BehaviorObject[],
  actionName: string,
  viewMode: 'DESKTOP' | 'MOBILE',
) {
  return behaviors.filter((behavior) => {
    // @ts-expect-error
    const behaviorViewMode = (behavior?.viewMode || 'DESKTOP').toUpperCase();
    return behavior.action === actionName && behaviorViewMode === viewMode;
  });
}
